import { PlayFill } from 'react-bootstrap-icons'
import { TextPattern, VideoImage } from '../images';
import { useState } from 'react';
import { Container, Row, Spinner } from 'react-bootstrap';
import ReactPlayer from 'react-player';
import { Link } from 'react-router-dom';
import { VideoModal } from './video-modal';

const VideoSection = () => {
  const [showPlayer, setShowPlayer] = useState(false);
  const [isPlayerLoading, setIsPlayerLoading] = useState(false);
  const videoUrl = process.env.REACT_APP_YT_VIDEO_URL || '';

  return (
    <section className="video py-5 overflow-hidden">
      <Container fluid>
        <Row>
          <div className="video-content open-up" data-aos="zoom-out">
            <div className="video-bg">
              <img src={VideoImage} alt="video" className="video-image img-fluid" />
            </div>
            <div className="video-player">
              <Link 
                to="#"
                className="youtube" 
                onClick={() => setShowPlayer(true)}
              >
                <PlayFill size={36} />
                <img src={TextPattern} alt="pattern" className="text-rotate" />
              </Link>
            </div>
          </div>
        </Row>
      </Container>

      <VideoModal show={showPlayer} onHide={() => {
        setShowPlayer(false);
        setIsPlayerLoading(false);
      }}>
        {
          isPlayerLoading ? <Spinner animation="grow" variant='light' /> : (
            <ReactPlayer
              url={videoUrl}
              controls
              width='100%'
              height='600px'
              onReady={() => setIsPlayerLoading(false)}
            />
          )
        } 
      </VideoModal>
    </section>
  );
};

export default VideoSection;